import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_j68hef5geu) — verbatim comment, real reviewer first name, location and rating.
export const review_gp1: FaireReviewEntity = {
  token: "review_gp1",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_txmj9tdafw",
  reviewType: "product",
  reviewerName: "Nichole",
  reviewerLocation: "Cabot, AR, United States",
  stars: 5,
  reviewText: "My brother purchased me a pair. When I saw these, I knew I had to share the love! Hopefully customers will enjoy them as well.",
  reviewDate: "Jun 24, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
